<template>
  <div slot="header" class="pl-7 pr-10 pb-6">
    <v-col class="pl-0">
      <div class="primary1--text headline font-weight-bold">
        <span v-if="isAdminBrasil()">ADICIONAR</span>
        <span v-if="!isAdminBrasil()">VISUALIZAR</span>  
        MANUAIS</div>
    </v-col>

    <v-row>
      <v-col cols="12">
        <b> Manual Atual : </b>
        <template v-if="manualVigente && manualVigente !== ''">
          <span>{{ manualVigente }}</span>
          <v-icon 
            color="primary"
            small
            class="ml-2"
            style="cursor: pointer"
            @click="downloadFile">
            mdi-download
          </v-icon>
        </template>
      </v-col>
    </v-row>
    <v-row v-if="isAdminBrasil()">
      <v-col cols="12"><p>Novo manual</p> </v-col>
      <v-col cols="12" align="center">
        <div class="drag-doc-area">
          <v-row no-gutters align="center" justify="center">
            <v-col cols="6" class="drag-text-icon my-12">
              <v-row no-gutters justify="center" align="center">
                <input type="file" @input="filesChange($event)" accept=".pdf" class="input-file" :value="fileInput" />
                <v-col cols="3" class="icon">
                  <icon name="paperclip" :size="40" style="cursor: pointer" class="mx-6 my-5" tooltip="Importar" />
                </v-col>
                <v-col cols="9" class="px-4 fontColor--text subtitle-2" v-if="file == ''">
                  Arraste e solte seu arquivo aqui ou <span class="text">clique</span> para localizar
                </v-col>
                <v-col cols="9" class="px-4" v-else>
                  <div>Nome do arquivo: {{ dadosArquivo.nome }}</div>
                  <div>Tamanho do arquivo: {{ dadosArquivo.tamanho }} KB</div>
                </v-col>
              </v-row>
            </v-col>
          </v-row>
        </div>
      </v-col>
      <v-col cols="12"><p>O arquivo deve ter no máximo 15 MB e estar no formato PDF.</p> </v-col>
      <v-col cols="auto" align="end" v-if="isAdminBrasil()">
        <button-cadu @click="salvar" :disabled="dadosArquivo.nome == ''"> SALVAR </button-cadu>
      </v-col>
    </v-row>
    <SucessoModal :genericMessage="genericMessage" :showSucess="showSucess" @close="closeSucessModal" />
    <overlay-loading v-model="loadingOverlay" />
    <error-modal v-model="error" :errObj="errObj" />
  </div>
</template>

<script>
import Manual from '@/services/Manual/Manual'
import jwtDecode from 'jwt-decode'

export default {
  components: {},
  data() {
    return {
      dadosArquivo: {
        nome: '',
        tamanho: '',
        tipoDocumento: ''
      },
      tokenBearer: localStorage.getItem('tokenBearer'),
      role: jwtDecode(localStorage.getItem('tokenBearer')).role,
      file: '',
      fileInput: '',
      formData: '',
      inputFile: '',
      manualArquivo: '',
      genericMessage: '',
      manualVigente: '',
      showSucess: false,
      loadingOverlay: false,
      error: false,
      errObj: {
        status: 'Status',
        error: 'Erro'
      }
    }
  },
  async created() {
    this.loadingOverlay = true
    this.atualizarManual()
  },
  methods: {
    isAdminBrasil() {
      return this.role === 'admin_brasil'
    },
    filesChange(e) {
      this.fileInput = ''
      this.inputFile = undefined
      this.formData = new FormData()

      let files = e.target.files || e.dataTransfer.files
      this.inputFile = files[0]
      let file = files[0]

      this.dadosArquivo.nome = file.name
      this.dadosArquivo.tamanho = (file.size / 1024).toFixed(2)
      this.dadosArquivo.tipo = file.type
      this.createFile(files[0])
    },
    createFile(file) {
      var reader = new FileReader()
      var vm = this

      reader.onloadend = (e) => {
        vm.file = e.target.result
      }

      reader.readAsDataURL(file)
    },
    async salvar() {
      this.loadingOverlay = true
      this.manualArquivo = new Manual(this.tokenBearer, this.$appConfig.config.API, this.$idUnimed)

      this.formData = new FormData()
      this.formData.append('manualArquivo', this.inputFile)
      this.formData.append('nome', this.dadosArquivo.nome)
      this.formData.append('tamanho', this.dadosArquivo.tamanho)
      this.formData.append('tipo', this.dadosArquivo.tipoDocumento)

      this.manualArquivo
        .setManual(this.formData)
        .then(() => {
          this.loadingOverlay = false
          this.genericMessage = 'Manual atualizado com sucesso!'
          this.showSucess = true
        })
        .catch((err) => {
          this.loadingOverlay = false
          this.errObj.status = err.responseManual.status
          this.errObj.error = err.responseManual.message
        })
        .finally(() => {
          this.loadingOverlay = false
          this.atualizarManual()
        })
    },
    async downloadFile() {
      this.loadingOverlay = true
          let arquivo = `${this.$appConfig.config.API}/api/arquivos/manual/`;
          let manual = new Manual(this.tokenBearer, this.$appConfig.config.API, this.$idUnimed);
          try {
            let uuidArquivo = await manual.getUuid()
            arquivo += uuidArquivo.data
            let response = await manual.exportar(arquivo)
            let content = response.headers['content-disposition']
            const url = window.URL.createObjectURL(new Blob([response.data]))
            const link = document.createElement('a')
            link.href = url
            link.setAttribute('download', content.substring(content.indexOf('"'), content.lastIndexOf('"')))
            document.body.appendChild(link)
            link.click()
            this.loadingOverlay = false
            this.showSuccess = true

          } catch (err) {
            this.loadingOverlay = false
            this.error = true
            console.error(err)
            this.showError = true
            this.errObj.status = err.responseManual.status
            this.errObj.error = err.responseManual.message
          }
    },
    async atualizarManual() {
      this.loadingOverlay = true
      this.atualizaManual = new Manual(this.tokenBearer, this.$appConfig.config.API, this.$idUnimed)

      await this.atualizaManual
        .getNome()
        .then((res) => {
          this.manualVigente = res.data
        })
        .catch((err) => {
          this.errObj.error = 'Não foi possivel carregar o manual atual. '
          console.error(err)
          this.error = true
        })
      this.loadingOverlay = false
    },
    closeSucessModal() {
      this.showSucess = false
    }
  }
}
</script>

<style lang="sass" scope>
.drag-doc-area
  position: relative
  border-radius: 22px
  background-color: #dee2e6
  width: 90%
  height: 200px

.drag-text-icon
  width: 100%

.icon
  width: 100%
  border-radius: 22px
  background-color: #fff
  color: #00995d
  display: block

.text
  cursor: pointer
  color: #00995d

.input-file
  opacity: 0
  position: absolute
  top: 0
  height: 180px
  width: 100%

.drag-text-file
  font-family: 'Trebuchet MS' !important
  font-size: 0.875rem
  color: rgba(0, 0, 0, 0.54)
  display: flex
  flex-direction: row
  margin: 8px

.input-file :hover
  cursor: pointer
</style>
